import { AxiosRequestConfig } from 'axios';
import { axiosInstance } from 'shared/lib/axios';
import { CountryListDTO, CountryListRequest } from './types';

export const getCountryList = (payload: CountryListRequest, config?: AxiosRequestConfig): Promise<CountryListDTO> => {
  return axiosInstance.get(`/api/country/all`, {
    params: payload,
    paramsSerializer: {
      indexes: null,
    },
    ...config,
  });
};

export const activateCountry = (countryId: string): Promise<void> => {
  return axiosInstance.put(`/api/country/${countryId}/activate`);
};

export const deactivateCountry = (countryId: string): Promise<void> => {
  return axiosInstance.put(`/api/country/${countryId}/deactivate`);
};
